import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const MathCaptcha = ({ onValidation, required = true }) => {
    const [captcha, setCaptcha] = useState({ question: '', answer: 0 });
    const [userAnswer, setUserAnswer] = useState('');
    const [isValid, setIsValid] = useState(false);
    const [error, setError] = useState('');

    // Generar nueva pregunta matemática
    const generateCaptcha = () => {
        const operations = ['+', '-', '*'];
        const operation = operations[Math.floor(Math.random() * operations.length)];

        let num1, num2, answer, question;

        switch (operation) {
            case '+':
                num1 = Math.floor(Math.random() * 50) + 1;
                num2 = Math.floor(Math.random() * 50) + 1;
                answer = num1 + num2;
                question = `${num1} + ${num2}`;
                break;
            case '-':
                num1 = Math.floor(Math.random() * 50) + 25;
                num2 = Math.floor(Math.random() * 25) + 1;
                answer = num1 - num2;
                question = `${num1} - ${num2}`;
                break;
            case '*':
                num1 = Math.floor(Math.random() * 10) + 1;
                num2 = Math.floor(Math.random() * 10) + 1;
                answer = num1 * num2;
                question = `${num1} × ${num2}`;
                break;
            default:
                num1 = 5;
                num2 = 3;
                answer = 8;
                question = '5 + 3';
        }

        setCaptcha({ question, answer });
        setUserAnswer('');
        setIsValid(false);
        setError('');
    };

    // Validar respuesta
    const validateAnswer = (value) => {
        const numValue = parseInt(value);
        const valid = numValue === captcha.answer;
        setIsValid(valid);

        if (value && !valid) {
            setError('Respuesta incorrecta');
        } else {
            setError('');
        }

        // Notificar al componente padre
        onValidation(valid);
        return valid;
    };

    // Manejar cambio en el input
    const handleInputChange = (e) => {
        const value = e.target.value;
        setUserAnswer(value);

        if (value) {
            validateAnswer(value);
        } else {
            setIsValid(false);
            setError('');
            onValidation(false);
        }
    };

    // Generar CAPTCHA al montar el componente
    useEffect(() => {
        generateCaptcha();
    }, []);

    return (
        <div className="mb-4">
            <label className="block text-sm font-semibold text-gray-800 mb-2">
                Verificación de seguridad {required && <span className="text-red-500">*</span>}
            </label>

            <div className="flex items-center space-x-3">
                {/* Pregunta del CAPTCHA */}
                <div className="flex items-center space-x-2 bg-gray-100 px-4 py-3 rounded-lg border-2 border-gray-400">
                    <span className="text-lg font-mono font-bold text-gray-800">
                        {captcha.question} = ?
                    </span>
                </div>

                {/* Input de respuesta */}
                <input
                    type="number"
                    value={userAnswer}
                    onChange={handleInputChange}
                    placeholder="Respuesta"
                    className={`w-24 text-center ${error ? 'input-error' : isValid ? 'input-success' : ''}`}
                    required={required}
                />

                {/* Botón de refrescar */}
                <button
                    type="button"
                    onClick={generateCaptcha}
                    className="p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
                    title="Generar nueva pregunta"
                >
                    <RefreshCw className="h-5 w-5" />
                </button>

                {/* Indicador visual */}
                {userAnswer && (
                    <div className="flex items-center">
                        {isValid ? (
                            <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-sm">✓</span>
                            </div>
                        ) : (
                            <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center">
                                <span className="text-white text-sm">✗</span>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {error && (
                <p className="mt-1 text-sm text-red-600 font-medium">{error}</p>
            )}

            {isValid && (
                <p className="mt-1 text-sm text-green-600 font-medium">¡Correcto!</p>
            )}
        </div>
    );
};

export default MathCaptcha;